import { all, fork, takeEvery } from "redux-saga/effects";

import onAppReady from "./onAppReady";
import onUserLogin from "./onUserLogin";
import onUserLogout from "./onUserLogout";
import onSessionRejected from "./onSessionRejected";
import onRoutePop from "./onRoutePop";
import restoreFromCache from "./restoreFromCache";

import { CONSTANTS as USER } from "@lifepay/redux-subsystem-user";

export default function* init({ gqlclient }) {
  // start stuff once
  // all(call) waits for completion
  // all(fork) doesn't wait for completion and yields immediately
  yield all([fork(restoreFromCache), fork(onAppReady, { gqlclient })]);
  // catching page reload
  yield takeEvery(
    (action) =>
      action.type === "@@router/LOCATION_CHANGE" &&
      action.payload.action === "POP",
    onRoutePop
  );
  // start stuff on every action:
  yield takeEvery(USER.START_SESSION_SUCCESS, onUserLogin, { gqlclient });
  yield takeEvery(USER.LOG_OUT, onUserLogout, { gqlclient });
  yield takeEvery(USER.CONFIRM_SESSION_STATUS_REJECTED, onSessionRejected);
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/saga.js